// Screen `signature-verify` (owner: doc-signing). Drop a PDF to see whether it is a sealed document
// of this instance; the check is the SHA-256 of the file, computed in the browser.
import { createFileRoute } from '@tanstack/react-router';
import { VerifyPage } from '../../features/signatures/VerifyPage';

export const Route = createFileRoute('/_public/verify')({
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: VerifyPage,
});
